module.exports = __webpack_public_path__ + "static/media/rainStrong.2b97c3d7.svg";